import api from "../../../api/axios";

const getUsers = async (params = {}) => {
  const response = await api.get("/api/v1/power/users", { params });
  return response.data;
};

const getUserById = async (id) => {
  const response = await api.get(`/api/v1/power/users/${id}`);
  return response.data;
};

const createUser = async (payload) => {
  const response = await api.post("/api/v1/power/users", payload);
  return response.data;
};

const updateUser = async ({ id, data }) => {
  const response = await api.patch(`/api/v1/power/users/${id}`, data);
  return response.data;
};

const updateUserPermissions = async ({ id, permissions }) => {
  const response = await api.patch(`/api/v1/power/users/${id}/permissions`, {
    permissions,
  });

  return response.data;
};

const changeUserStatus = async ({ id, status }) => {
  const response = await api.patch(`/api/v1/power/users/${id}/status`, {
    status,
  });

  return response.data;
};

const disableUser = async (id) => {
  const response = await api.patch(`/api/v1/power/users/${id}/disable`);
  return response.data;
};

const resendSetupInvite = async (id) => {
  const response = await api.post(
    `/api/v1/power/users/${id}/resend-setup-invite`,
  );

  return response.data;
};

const userService = {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  updateUserPermissions,
  changeUserStatus,
  disableUser,
  resendSetupInvite,
};

export default userService;
